<script setup lang="ts">
const text = 'Relax & Energie';
</script>

<template>
  <section
    class="bg-client-gray py-r12 lg:py-r18 gap-r12 xl:gap-r18 flex w-full flex-col"
  >
    <Marquee style="--marquee-direction: forwards">
      <AppTextStroke
        stroke="var(--color-client-orange)"
        fill="#f0f0f0"
        class="block leading-[120%] font-bold"
      >
        {{ text }}
      </AppTextStroke>
    </Marquee>
    <ServicesRelaxSauna />
    <ServicesRelaxSolarium />
  </section>
</template>
